import React, { useState, useEffect, useContext } from "react";
import axios from 'axios'
import DataTable from 'react-data-table-component';
import html2canvas from "html2canvas"
import { jsPDF } from "jspdf"

import Partidas from "./Partidas";
import Pagos from "./Pagos";
import PartidasPrint from "./PartidasPrint";
import { NumeroALetras } from "./PriceToText"
import { GlobalContext, HOST } from "./context/GlobalContext"

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Offcanvas from 'react-bootstrap/Offcanvas'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'

import laJornada from './img/logo.png'

import './App.css';
import { BookFill, CartCheckFill, CashStack, Clipboard2CheckFill, CreditCardFill, EyeFill, ListColumns, PencilFill, SendCheckFill, X } from "react-bootstrap-icons";

const COMPRAS_UPDATE_API = HOST + '/api/inv/ordenCompra/update/'
const COMPRAS_CANCEL_API = HOST + '/api/inv/ordenCompra/cancel/'
const APROVACION_API = HOST + '/api/inv/ordenCompra/approve/'
const APROVACION_STATUS_API = HOST + '/api/inv/ordenCompra/approving/'
const COMPRAS_MASSIVE_API = HOST + '/api/inv/ordenCompra/carga/'

const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
const DATE_FORMAT_SHORT = new Intl.DateTimeFormat('es', { year: 'numeric', month: 'long', day: '2-digit', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })

function Compras() {
  const { setGlobalLoading,
    proveedoresList,
    partidasList,
    librosList,
    comprasList,
    showMesage,
    userName,
    callback,
    token,
    rol,
    formDataToJson,
    setMailBody,
    setMailTitle,
    setShowMesage,
    dateForm,
    getLibros,
    getPartidas,
    setCallback,
    getNombreLibro,
    getNombreProveedor,
    getNombreEstado,
    getOrdenesCompra } = useContext(GlobalContext);

  const [ show, setShow ] = useState(false)
  const [ showOrder, setShowOrder ] = useState(false)
  const [ showCancel, setShowCancel ] = useState(false)
  const [ showDetail, setShowDetail ] = useState(false)
  const [ showPay, setShowPay ] = useState(false)
  const [ action, setAction ] = useState('Crear Proveedor')
  const [ showMassive, setShowMassive ] = useState(false)
  const [ showPrint, setShowPrint ] = useState(false)

  const [ orden, setOrden ] = useState({ idOrden: 0 })
  const [ idOrden, setIdOrden ] = useState({ })
  const [ idProveedor, setIdProveedor ] = useState(null)
  const [ proveerdor, setProveedor ] = useState(null)

  const [ , setIdRequisicion ] = useState(null)
  const [ fecha, setFecha ] = useState(null)
  const [ subtotal, setSubtotal ] = useState(null)
  const [ impuestoRetenido, setImpuestoRetenido ] = useState(null)
  const [ impuestoTrasladado, setImpuestoTrasladado ] = useState(null)
  const [ descuento, setDescuento ] = useState(null)
  const [ total, setTotal ] = useState(null)
  const [ tipoPago, setTipoPago ] = useState(null)
  const [ moneda, setMoneda ] = useState('MX')
  const [ anticipo, setAnticipo ] = useState(null)
  const [ descuentoProv, setDescuentoProv ] = useState(null)
  const [ comentario, setComentario ] = useState(null)
  const [ importePagado, setImportePagado ] = useState(null)
  const [ estatus, setEstatus ] = useState(null)
  const [ fechaEstatus, setFechaEstatus ] = useState(null)
  const [ usuarioRegistra, setUsuarioRegistra ] = useState(null)
  const [ fechaRegistra, setFechaRegistra ] = useState(null)
  const [ usuarioAutoriza, setUsuarioAutoriza ] = useState(null)
  const [ fechaAutoriza, setFechaAutoriza ] = useState(null)
  const [ usuarioCancela, setUsuarioCancela ] = useState(null)
  const [ fechaCancela, setFechaCancela ] = useState(null)
  const [ isDisabled, ] = useState( parseInt(rol) === 1 ? true : false )

  const [ loading, setLoading ] = useState( false )
  const [ file, setFile ] = useState(null)
  const [ partidasRes, setPartidasRes ] = useState([])

  useEffect(() => {
    setGlobalLoading( true )
    getOrdenesCompra()
    if( librosList.length == 0 ) getLibros()
  }, []);

  useEffect(() => {
    if(showPrint) {
      let temp = []      
      temp.push(... partidasList)
      
      /*for( let j = 0; j < 15; j++ ){
        temp.push(... partidasList)
      }*/

      console.log("large list", temp)

      let numberOfList = 0
      let mainList = temp.splice( 0, 20 )
      let resultList = []
      
      if( temp.length > 20 ) {
        let rest = temp.length

        console.log("operations", rest, Math.ceil( rest / 30 ))
        numberOfList = Math.ceil( rest / 30 )
      }

      resultList[0] = mainList 
      console.log("numberOfList", numberOfList)

      for ( let i = 0; i < numberOfList; i++ ) {      
        resultList[ i + 1 ] = temp.splice( 0, 30 )
      }

      setPartidasRes( resultList )
      console.log("resultante list", resultList)
    }
  }, [ partidasList ]);

  useEffect(() => {
    if( showMesage && callback )
      setShowMesage(false)
  }, [ callback ]);

  const showForm = (item) => {

    if( item ){
      setAction('Actualizar orden de compra')
      fillForm( item )
    } else {
      setAction('Nueva orden de compra')
      clearForm()
    }

    setShow(true)
  }

  const fillForm = (item) => {
    let date  = new Date(item.fecha)
    let dateP =  date.getFullYear() + "-" + ((date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "-" + (date.getDate() < 10 ? "0" + date.getDate() : date.getDate())

    setIdOrden(item.idOrden)
    setIdProveedor(item.idProveedor)
    setIdRequisicion(item.idRequisicion)
    setFecha(dateP)
    setSubtotal(item.subtotal)
    setImpuestoRetenido(item.impuestoRetenido)
    setImpuestoTrasladado(item.impuestoTrasladado)
    setDescuento(item.descuento)
    setTotal(item.total)
    setTipoPago(item.tipoPago)
    setMoneda(item.moneda)
    setAnticipo(item.anticipo)
    setDescuentoProv(item.descuentoProv)
    setComentario(item.comentario)
    setImportePagado(item.importePagado)
    setEstatus(item.estatus)
    setFechaEstatus(item.fechaEstatus)
    setUsuarioRegistra(item.usuarioRegistra)
    setFechaRegistra(item.fechaRegistra)
    setUsuarioAutoriza(item.usuarioAutoriza)
    setFechaAutoriza(item.fechaAutoriza)
    setUsuarioCancela(item.usuarioCancela)
    setFechaCancela(item.fechaCancela)
  }

  const clearForm = () => {
    setIdOrden(null)
    setIdProveedor(null)
    setIdRequisicion(null)
    setFecha(null)
    setSubtotal(null)
    setImpuestoRetenido(null)
    setImpuestoTrasladado(null)
    setDescuento(null)
    setTotal(null)
    setTipoPago(null)
    setMoneda('MX')
    setAnticipo(null)
    setDescuentoProv(null)
    setComentario(null)
    setImportePagado(null)
    setEstatus(null)
    setFechaEstatus(null)
    setUsuarioRegistra(null)
    setFechaRegistra(null)
    setUsuarioAutoriza(null)
    setFechaAutoriza(null)
    setUsuarioCancela(null)
    setFechaCancela(null)
  }

  const updateItem = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    var form = document.getElementById('comprasForm');
		var formData = new FormData(form);
    var showStep = false

    formData.append('fecha', dateForm(fecha));

    var json = formDataToJson(formData)
    
    console.log('json to update compra', json, json.idOrden)

    if( !json.idOrden ) showStep = true

    axios.post(COMPRAS_UPDATE_API + '?u=' + userName, json, {
			headers: { 'content-type': 'application/json' }
    }).then(result => {
      console.log("result update", result.data)
      getOrdenesCompra()
      setShow(false)
      setGlobalLoading( false )

      if( showStep ) setOrden( result.data )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setCallback(false)
      setGlobalLoading( false )
    })
  }

  const cancelOrden = () => {
    setGlobalLoading( true )

    axios.post(COMPRAS_CANCEL_API + '/' + orden.idOrden, {}, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      getOrdenesCompra()
      setShow(false)
      setGlobalLoading( false )
      setShowCancel(false)

      setShowMesage(true)
      setMailTitle('Cancelado')
      setMailBody(`La orde de compra ha sido cancelada.`)
      setCallback(false)

    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setCallback(false)
      setGlobalLoading( false )
    })
  }

  const approveStatus = (id) => {
    setGlobalLoading( true )

    axios.post(APROVACION_API + '/' + id, {}, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result approve", result.data)
      setShowMesage(true)

      if( result.data === 'NO_AUTH'){ 
        setMailTitle('Error')
        setMailBody(`No se encontro una llave valida para este servicio.`)
      } else {
        setMailTitle('Enviado')
        setMailBody(`La orden de compra ah sido enviada para aprobación.`)
      }
      
      setCallback(false)

      getOrdenesCompra()
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setCallback(false)
      setGlobalLoading( false )
    })
  }

  const approvingStatus = (id, status) => {
    setGlobalLoading( true )
    console.log("token", token)

    axios.post(APROVACION_STATUS_API + '/' + id + "/" + status, {}, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result approving", result.data)
      setShowMesage(true)

      if( result.data === 'NO_AUTH'){ 
        setMailTitle('Error')
        setMailBody(`No se encontro una llave valida para este servicio.`)
      } else {
        setMailTitle('Enviado')
        setMailBody(`La orden de compra ah sido ${status.replace(/_/g, " ")}.`)
      }

      setCallback(false)

      getOrdenesCompra()
      setShowOrder(false)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setCallback(false)
      setGlobalLoading( false )
    })
  }

  const onChangeProv = (id) => {
    let prov = getNombreProveedor(id)
    if( prov ) setDescuentoProv( prov.descuento )

    setIdProveedor(id)
  }

  const viewOrden = (item) => {
    setOrden(item)
    setShowOrder(true)
  }

  const selectOrden = (item) => {
    setOrden( item )
    setShowDetail( true )
  }

  const selectOrdenPay = (item) => {
    setOrden( item )
    setShowPay( true )
  }

  const viewPrint = () => {
    setGlobalLoading( true )

    setProveedor( getNombreProveedor(orden.idProveedor) )
    getPartidas( orden.idOrden )
    setShowPrint(true)
  }

  const confirmCancel = ( item ) => {
    setOrden(item)
    setShowCancel(true)
  }

  const showMasiveFile = () => {
    setShowMassive(true)
  }

  const sendForm = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    setLoading( true )

    var form = document.getElementById('visitorForm')
    var formData = new FormData(form)

    axios.post(COMPRAS_MASSIVE_API, formData, {
      headers: {
        'Content-type': 'multipart/form-data; charset=utf-8',
        'Authentication': token
      }
    })
    .then(rest => {
      console.log("result uploading photo", rest.data)
      setGlobalLoading( false )
      setLoading( false )
      setShowMassive( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
      setLoading( false )
    })
  }

  const getOrden = () => {
    return (
      <>
        { orden && orden.idOrden > 0 && 
          <Container>
            <Row>
              <div>
                <Container>
                  <Row>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Proveedor </div>
                      <div>{ getNombreProveedor(orden.idProveedor).razonSocial }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Fecha </div>
                      <div>{ DATE_FORMAT_SHORT.format((new Date( orden.fecha )).getTime()) }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Creada por </div>
                      <div>{ orden.usuarioRegistra.toUpperCase() }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Descuento de Proveedor ( % )</div>
                      <div>{ orden.descuentoProv + ' %'}</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> SubTotal </div>
                      <div>{ CURRENCY_FORMAT.format( orden.subtotal ) }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Impuesto Retenido </div>
                      <div>{ CURRENCY_FORMAT.format( orden.impuestoRetenido ) }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Impuesto Trasladado </div>
                      <div>{ orden.impuestoTrasladado }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Descuento </div>
                      <div>{ CURRENCY_FORMAT.format( orden.descuento ) }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Total </div>
                      <div>{ CURRENCY_FORMAT.format( orden.total ) }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Tipo Pago </div>
                      <div style={{ textTransform: 'capitalize' }}>{ orden.tipoPago }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Moneda </div>
                      <div>{ orden.moneda }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Anticipo </div>
                      <div>{ CURRENCY_FORMAT.format( orden.anticipo ) }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Comentarios </div>
                      <div>{ orden.comentario }</div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Row>
            <Row>
              <br/>
              <div align="center" style={{ marginBottom: '25px' }}>
                {/*<button type="button" className="cancel-btn" onClick={ () => setShowOrder(false) } >{ 'Cerrar' }</button>&nbsp;&nbsp;*/}
                <button type="button" className="grl-btn" onClick={ () => viewPrint(orden) } >{ 'Visualizar Orden de Compra' }</button>&nbsp;&nbsp;
                { (parseInt(rol) === 1 && orden.estatus === 'por_autorizar') && 
                <>
                  <hr style={{ color: '#ae0107' }} />
                  <div style={{ marginTop: '15px' }}>
                    <button type="button" className="cancel-btn" onClick={ () => approvingStatus(orden.idOrden, 'rechazada') } >{ 'Rechazar Compra' }</button>&nbsp;&nbsp;
                    <button type="button" className="grl-btn" onClick={ () => approvingStatus(orden.idOrden, 'autorizada') }>{ 'Aprobar Compra' }</button>
                  </div>
                </>
                }
              </div>
            </Row>
            <Row>
              <br/>
              <div className="section-subtitle"> Detalle de la orden</div>
              <br/>
              <div>
                <Partidas orden={ orden } readOnly={ true } setShowDetail={ setShowDetail } />
              </div>
            </Row>
          </Container>
        }
      </>
    )
  }

  const getForm = () => {
    return (
      
        <Container>
          <Row>
            <div>
              <input type="hidden" name="idOrden" value={ idOrden } />
              <input type="hidden" name="estatus" value={ idOrden ? estatus : 'en_espera' } />
              <input type="hidden" name="fechaEstatus" value={ fechaEstatus } />
              <input type="hidden" name="usuarioRegistra" value={ usuarioRegistra } />
              <input type="hidden" name="fechaRegistra" value={ fechaRegistra } />
              <input type="hidden" name="usuarioAutoriza" value={ usuarioAutoriza } />
              <input type="hidden" name="fechaAutoriza" value={ fechaAutoriza } />
              <input type="hidden" name="usuarioCancela" value={ usuarioCancela } />
              <input type="hidden" name="fechaCancela" value={ fechaCancela } />
              <Container>
                <Row>
                  <Col md="6">
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Proveedor">
                        <Form.Select required disabled={isDisabled} name="idProveedor" value={ idProveedor } onChange={ (e) => onChangeProv( e.target.value ) }>
                          <option>Selecciona una opción</option>
                          { proveedoresList.map( item => (
                            <option key={ item.idProveedor } value={ item.idProveedor }>{ item.razonSocial }</option>
                          ))}
                        </Form.Select>
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Fecha">
                        <Form.Control required disabled={isDisabled} type="date" name="fecha" max={new Date().toISOString().split("T")[0]} value={ fecha } placeholder="" onChange={ (e) => setFecha( e.target.value ) }/>
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  
                  {/*
                  <Col md="6">
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="SubTotal">
                        <Form.Control required disabled={isDisabled} type='number' name="subtotal" value={ subtotal } onChange={ (e) => setSubtotal( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Impuesto Retenido">
                        <Form.Control required disabled={isDisabled} type='number' name="impuestoRetenido" value={ impuestoRetenido } onChange={ (e) => setImpuestoRetenido( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Impuesto Trasladado">
                        <Form.Control required disabled={isDisabled} type='number' name="impuestoTrasladado" value={ impuestoTrasladado } onChange={ (e) => setImpuestoTrasladado( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Descuento">
                        <Form.Control required disabled={isDisabled} type='number' name="descuento" value={ descuento } onChange={ (e) => setDescuento( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Total">
                        <Form.Control required disabled={isDisabled} type='number' name="total" value={ total } onChange={ (e) => setTotal( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  */}
                  <Col md="6">
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Tipo Pago">
                        <Form.Select required disabled={isDisabled} name="tipoPago" value={ tipoPago } onChange={ (e) => setTipoPago( e.target.value ) }>
                          <option>Selecciona una opción</option>
                          <option value={ 'efectivo' }>Efectivo</option>
                          <option value={ 'cheque' }>Cheque</option>
                          <option value={ 'transferencia' }>Transferencia</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group className='mb-3'>
                      <input type="hidden" name="moneda" value={ moneda } />
                      <FloatingLabel label="Moneda">
                        <Form.Control required disabled value={ moneda } onChange={ (e) => setMoneda( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Anticipo">
                        <Form.Control required disabled={isDisabled} name="anticipo" value={ anticipo } onChange={ (e) => setAnticipo( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Descuento de Proveedor (%)">
                        <Form.Control required disabled={isDisabled} name="descuentoProv" value={ descuentoProv } onChange={ (e) => setDescuentoProv( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>

                  <Col md="12">
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Comentario">
                        <Form.Control required disabled={isDisabled} name="comentario" value={ comentario } onChange={ (e) => setComentario( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  {/* <Col md="6">
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Importe Pagado">
                        <Form.Control required disabled={isDisabled} type='number' name="importePagado" value={ importePagado } onChange={ (e) => setImportePagado( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col> */}
                </Row>
              </Container>
            </div>
          </Row>
        </Container>
    )
  }

  const printPDF = () => {
    setGlobalLoading( true )
    let pages = partidasRes.length
    let slide = 0

    const infoPageElement = document.getElementById("App");
    const pdf = new jsPDF('p', 'mm', 'a4');

    function htmlCanvas() {
      slide++

      if( slide >= pages ) {
        pdf.save(`OrdenCompra_${orden.idOrden}.pdf`);
        setGlobalLoading( false )

        return
      }

      pdf.addPage();
      const elem = document.getElementById("App_" + slide);
      console.log("element", slide, elem)

      html2canvas(elem, {
        scale:3,
        useCORS: true,
        allowTaint: false
      }).then(canvas => {
        pdf.addImage(canvas.toDataURL("image/jpeg"), "JPEG", 5, 5, 200, 288);
        console.log("image added")
        htmlCanvas()
      })
    }

    html2canvas(infoPageElement, {
      onclone: document => {},
      scale:3,
      useCORS: true,
      allowTaint: false
    }).then(canvas => {

      pdf.addImage(canvas.toDataURL("image/jpeg"), "JPEG", 5, 5, 200, 288, '', 'FAST');
      htmlCanvas()
    });

  };

  /**************************************** Data Table ****************************************/

  const [filterText, setFilterText] = useState('');
	const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);

  const columns = [
    {
      name: <th># Orden</th>,
      selector: row => <div className="item-link" onClick={ () => viewOrden(row) }> 
        { '#' + (row.idOrden).toString().padStart(4, '0') } 
      </div>,
      sortable: true,
    },
    {
      name: <th>Fecha</th>,
      selector: row => DATE_FORMAT_SHORT.format((new Date( row.fecha )).getTime()),
      sortable: true,
    },
    {
      name: <th>Razon Social</th>,
      selector: row => getNombreProveedor(row.idProveedor) ? getNombreProveedor(row.idProveedor).razonSocial : "-",
      sortable: true,
    },
    {
      name: <th>Total</th>,
      selector: row => CURRENCY_FORMAT.format( row.total ),
      sortable: true,
    },
    {
      name: <th>Creada por</th>,
      selector: row => row.usuarioRegistra ? row.usuarioRegistra.toUpperCase() : '-',
      sortable: true,
    },
    {
      name: <th>Autorizada por</th>,
      selector: row => row.usuarioAutoriza ? row.usuarioAutoriza.toUpperCase() : '-',
      sortable: true,
    },
    {
      name: <th>Estatus</th>,
      selector: row => <div style={{ textTransform: 'uppercase' }}>{ row.estatus.replace(/_/g, " ") }</div>,
      sortable: true,
    },
    {
      cell: row => 
      <>
        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Resumen de la orden</Tooltip>}>
          <Clipboard2CheckFill onClick={ () => viewOrden(row) } className="table-icon" />
        </OverlayTrigger>
        { parseInt(rol) === 2 && 
          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Elementos</Tooltip>}>
            <ListColumns onClick={ () => selectOrden(row) } className="table-icon" />
          </OverlayTrigger>
        }
        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Pagos</Tooltip>}>
          <CashStack onClick={ () => selectOrdenPay(row) } className="table-icon" />
        </OverlayTrigger>
        { parseInt(rol) === 2 && 
          <>
            { (row.estatus === 'abierta' || row.estatus === 'rechazada') && 
              <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Solicitar aprobación</Tooltip>}>
                <CartCheckFill onClick={ () => approveStatus(row.idOrden) } className="table-icon" />
              </OverlayTrigger>
            }
            { row.estatus === 'autorizada' && 
              <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Enviar a proveedor</Tooltip>}>
                <SendCheckFill onClick={ () => approvingStatus(row.idOrden, 'enviada_a_proveedor') } className="table-icon" />
              </OverlayTrigger>
            }
            { (row.estatus === 'en_espera' || row.estatus === 'abierta' || row.estatus === 'rechazada') &&
              <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Editar orden</Tooltip>}>
                <PencilFill onClick={ () => showForm(row) } className="table-icon" />
              </OverlayTrigger>
            }
            { (row.estatus === 'en_espera' || row.estatus === 'abierta' || row.estatus === 'rechazada') &&
              <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Borrar</Tooltip>}>
                <X onClick={ () => confirmCancel(row) } className="table-icon" />
              </OverlayTrigger>
            }
          </>
        }
      </>,
      width: '240px'
    },
  ];

  useEffect(() => {
    if( comprasList.length > 0) {
      let data = []

      if(filterText && filterText !== '' ) {
        data = comprasList.filter(
          item => item.titulo && item.titulo.toLowerCase().includes(filterText.toLowerCase()),
        )
      } else data = comprasList

      setFilteredItems(data);
    }
  }, [ comprasList, filterText ]);

  /**************************************** Data Table ****************************************/

  return (
    <>
      <Modal show={showCancel} onHide={ () => setShowCancel(false) }>
        <Modal.Header closeButton>
        <div className="title-form">{ `Cancelar orden #${orden.idOrden}` }</div>
        </Modal.Header>
        <Modal.Body>{ `¿Seguro que desea cancelar la orden #${orden.idOrden}? Esta acción no se puede deshacer.` }</Modal.Body>
        <Modal.Footer>
          <button type="button" onClick={ () => setShowCancel(false) } className="cancel-btn">{ 'Cerrar' }</button>&nbsp;&nbsp;
          <button type="button" onClick={ () => cancelOrden() } className="grl-btn">{ 'Cancelar' }</button>
        </Modal.Footer>
      </Modal>

      <Modal show={showMassive} onHide={ () => setShowMassive(false) }>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Ordenes de compra - Carga Masiva' }</div>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form id='visitorForm' onSubmit={ sendForm }>
              <div>
                <div> Puedes subir un <span style={{ color: "#ae0107" }}>ARCHIVO</span> .xlsx para poder subir varias <b>Ordenes de compra</b> a la vez. para conocer que <span style={{ color: "#ae0107" }}>FORMATO</span> es necesario para realizar esta carga masiva, puedes descargar este <span style={{ color: "#ae0107", textDecoration: "underline" }}>TEMPLATE</span>.  </div>
                <br/>
                <input required className='file' type="file" name="libros" onChange={ (e) => setFile(e.target.files[0]) } style={{ fontSize: '11px' }} />
                <br/>
                <div align="right">
                  <Button disabled={ loading } className='single-btn' type="submit">
                    <Spinner animation="border" variant="light" role="status" className={ loading ? 'spin' : 'hide' }/>
                    <span className={ loading ? 'hide' : 'btn-text' }> Guardar </span>
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showPrint} onHide={ () => setShowPrint(false) } size="xl">
        <Modal.Header closeButton>
          <div className="title-form">{ 'Previo - Orden de Compra' }</div>
        </Modal.Header>
        <Modal.Body>
          <div align="right"><button type="button" onClick={ () => printPDF() } className="grl-btn">{ 'Descargar' }</button></div>
          <br/>
          <div id="App" className="app-container">
            <div id="infoApp" className="app">
              { orden != null && orden.idOrden != 0 &&
                <Container>
                  <Row>
                    <Col md={ 6 }>
                      <div> <img src={ laJornada } className="print-logo" /> </div>
                      <br/>
                      <div className="section-subtitle"> DEMOS DESARROLLO DE MEDIOS </div>
                      <div> AV CUAUHTÉMOC 1236 SANTA CRUZ </div>
                      <div> ATOYAC ALCALDÍA BENITO JUÁREZ </div>
                      <div> RFC: <b>DDM840626PM</b> </div>
                    </Col>
                    <Col md={ 6 }>
                      <div style={{ textAlign: 'right' }}>
                        <div className="title-form" style={{ textAlign: 'right', fontSize: '45px' }}> ORDEN DE COMPRA </div>
                        <br/>
                        <div> <span>Fecha:</span> <b>{ DATE_FORMAT_SHORT.format((new Date( orden.fecha )).getTime()) }</b> </div>
                        <div> <span>Folio:</span> <b>{ 'CON ' + orden.idOrden }</b> </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-5">
                    <Col md={ 6 }>
                      <div className="print-title"> PROVEEDOR </div> <br/>
                      { proveerdor != null &&
                        <>
                          <div className="section-subtitle"> { proveerdor.razonSocial } </div> <br/>
                          <div> { `${proveerdor.calle} ${proveerdor.numeroInt} ${proveerdor.numeroExt}, ${proveerdor.colonia}, ${getNombreEstado(proveerdor.idEstado).estado}` } </div>
                          <div> RFC: <b>{proveerdor.rfc}</b> </div> <br/>
                          
                          <div> Creado por: <b>{ orden.usuarioRegistra.toUpperCase() }</b> </div>
                          <div> Descuento: <b>{ orden.descuentoProv } %</b> </div>
                          <div> Impuestos: <b>{ proveerdor.iva } %</b> </div>
                          <div> Plazo: <b>{ proveerdor.diasVencimiento } días</b> </div>
                        </>
                      }
                    </Col>
                    <Col md={ 6 }>
                      <div id="resume">
                        <div className="print-title"> RESUMEN </div> <br/>
                        <Col md={ 12 }>
                          <Table responsive>
                            <tbody>
                              <tr>
                                <td> 
                                  <div className="section-subtitle"> SUBTOTAL: </div>
                                </td>
                                <td> 
                                  { CURRENCY_FORMAT.format(orden.subtotal) }
                                </td>
                              </tr>
                              <tr>
                                <td> 
                                  <div className="section-subtitle"> DESCUENTO: </div>
                                </td>
                                <td> 
                                  { CURRENCY_FORMAT.format(orden.descuento) }
                                </td>
                              </tr>
                              <tr>
                                <td> 
                                  <div className="section-subtitle"> IVA: </div>
                                </td>
                                <td> 
                                  { CURRENCY_FORMAT.format(orden.impuestoRetenido) }
                                </td>
                              </tr>
                              <tr>
                                <td> 
                                  <div className="section-subtitle"> TOTAL: </div>
                                </td>
                                <td> 
                                  <b>{ CURRENCY_FORMAT.format(orden.total) }</b>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                          <br/>
                          <div className="desc-form">{ NumeroALetras(orden.total) } M.N.
                          </div>
                          <div className="desc-form"> <b>Moneda:</b> MXN </div>
                        </Col>
                        <Col md={ 12 }>
                          <div className="print-title"> Comentarios </div> <br/>
                          <div>{ orden.comentario }</div>
                        </Col>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-5">
                    <Col md={ 12 } >
                      { partidasRes.length > 0 &&
                        <PartidasPrint partidasList={ partidasRes[0] } /> 
                      }
                    </Col>
                  </Row>

                  { /*partidasRes[0].length === 1 &&
                    <Row className="mt-5">
                      <Col md={ 7 }>
                        <div className="print-title"> Comentarios </div> <br/>
                        <div>{ orden.comentario }</div>
                      </Col>
                      <Col md={ 5 }>
                        <Table responsive>
                          <tbody>
                            <tr>
                              <td> 
                                <div className="section-subtitle"> SUBTOTAL: </div>
                              </td>
                              <td> 
                                { CURRENCY_FORMAT.format(orden.subtotal) }
                              </td>
                            </tr>
                            <tr>
                              <td> 
                                <div className="section-subtitle"> DESCUENTO: </div>
                              </td>
                              <td> 
                                { CURRENCY_FORMAT.format(orden.descuento) }
                              </td>
                            </tr>
                            <tr>
                              <td> 
                                <div className="section-subtitle"> IVA: </div>
                              </td>
                              <td> 
                                { CURRENCY_FORMAT.format(orden.impuestoRetenido) }
                              </td>
                            </tr>
                            <tr>
                              <td> 
                                <div className="section-subtitle"> TOTAL: </div>
                              </td>
                              <td> 
                                <b>{ CURRENCY_FORMAT.format(orden.total) }</b>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <br/>
                        <div className="desc-form">{ NumeroALetras(orden.total) } M.N.
                        </div>
                        <div className="desc-form"> <b>Moneda:</b> MXN </div>
                      </Col>
                    </Row>
                  */}
                </Container>
              }
            </div>
          </div>

          { partidasRes.length > 1 &&
            partidasRes.map((item, index) => {
              if( index !== 0 ) {
                return <>
                  <div id={ "App_" + index } className="app-container">
                    <div id={ "infoApp_" + index } className="app">
                      <Container>
                        <Row className="mt-5">
                          <Col md={ 12 } >
                            <PartidasPrint partidasList={ item } /> 
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  </div>
                  <br/>
                </>
              }
            })
          }

        </Modal.Body>
      </Modal>

      <Offcanvas show={showOrder} onHide={ () => setShowOrder(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ `Orden de Compra #${orden.idOrden}` }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="comprasForm" onSubmit={ updateItem }>
            { getOrden() }
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={show} onHide={ () => setShow(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ action }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="comprasForm" onSubmit={ updateItem }>
            { getForm() }
            <br/>
            <div align="center">
              <button type="button" className="cancel-btn" onClick={ () => setShow(false) } >{ 'Cancelar' }</button>&nbsp;&nbsp;
              <button type="submit" className="grl-btn">{ 'Guardar' }</button>
            </div>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={showDetail} className='offcanvas-custom' onHide={ () => setShowDetail(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form"> Detalle de Elementos </div>
            <div className="desc-form"> Administra los elementos a tu orden especificando cantidad y descuento. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div> { orden.idOrden > 0 ? <Partidas orden={ orden } setShowDetail={ setShowDetail } /> : <div>Selecciona una orden para conocer su detalle.</div> } </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={showPay} onHide={ () => setShowPay(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form"> Detalle de Pagos </div>
            <div className="desc-form"> Administra los pagos de tu orden. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div> <Pagos  orden={ orden } /> </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Container className='main-component'>
        <Row>
          <Col md={ 9 }>
            <div className="section-subtitle"> Ordenes de compras </div>
            <br/>
          </Col>
          <Col md={ 3 } align="right">
            { parseInt(rol) === 2 && <span className="single-btn" onClick={ () => showForm() } > Nuevo </span> }&nbsp;&nbsp;&nbsp;
            {/* parseInt(rol) === 2 && <span className="single-alt-btn" onClick={ () => showMasiveFile() } > Carga Masiva </span> */}
          </Col>
        </Row>
        <Row>
          <Col>
            { filteredItems.length > 0 && 
              <>
                {/*<Form.Group className='mb-3'>
                  <FloatingLabel label="Buscar">
                    <Form.Control id="search" value={filterText} onChange={ (e) => setFilterText(e.target.value) } placeholder="" />
                  </FloatingLabel>
                </Form.Group>*/}
              
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  pagination
                  paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                  persistTableHead
                />
              </>
            }
            { filteredItems.length === 0 && 
              <div>Sin registros</div>
            }
            {/*<Table responsive>
              <thead>
                <tr>
                  <th># Orden</th>
                  <th>Fecha</th>
                  <th>Razon Social</th>
                  <th>Total</th>
                  <th>Autorizada por</th>
                  <th>Estatus</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                { comprasList.length === 0 && 
                  <tr>
                    <td colSpan="6"> <div>Sin registros</div> </td>
                  </tr>
                }
                { comprasList.map( item => (
                  <tr key={ item.idOrden }>
                    <td> 
                      <div className="item-link" onClick={ () => viewOrden(item) }> 
                        { '#' + item.idOrden } 
                      </div>
                    </td>
                    <td>
                      { DATE_FORMAT_SHORT.format((new Date( item.fecha )).getTime()) }
                    </td>
                    <td> 
                      { getNombreProveedor(item.idProveedor) ? getNombreProveedor(item.idProveedor).razonSocial : "-" } 
                    </td>
                    <td> 
                      { CURRENCY_FORMAT.format( item.total ) } 
                    </td>
                    <td> 
                      { item.usuarioAutoriza ? item.usuarioAutoriza : '-' } 
                    </td>
                    <td> 
                      <div style={{ textTransform: 'uppercase' }}> { item.estatus.replace(/_/g, " ") } </div>
                    </td>
                    <td align="right"> 
                    <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Ver detalle y pagos</Tooltip>}>
                      <EyeFill onClick={ () => selectOrden(item) } className="table-icon" />
                    </OverlayTrigger>
                    { parseInt(rol) === 1 && item.estatus === 'por_autorizar' &&
                      <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Revisar orden</Tooltip>}>
                        <Clipboard2CheckFill onClick={ () => viewOrden(item) } className="table-icon" />
                      </OverlayTrigger>
                    }
                    { parseInt(rol) === 2 && 
                      <>
                        { item.estatus === 'abierta' && 
                          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Solicitar aprovación</Tooltip>}>
                            <CartCheckFill onClick={ () => approveStatus(item.idOrden) } className="table-icon" />
                          </OverlayTrigger>
                        }
                        { item.estatus === 'autorizada' && 
                          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Enviar a proveedor</Tooltip>}>
                            <SendCheckFill onClick={ () => approvingStatus(item.idOrden, 'enviada_a_proveedor') } className="table-icon" />
                          </OverlayTrigger>
                        }
                        { item.estatus === 'abierta' &&
                          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Editar orden</Tooltip>}>
                            <PencilFill onClick={ () => showForm(item) } className="table-icon" />
                          </OverlayTrigger>
                        }
                        { item.estatus === 'abierta' &&
                          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Borrar</Tooltip>}>
                            <X onClick={ () => confirmCancel(item) } className="table-icon" />
                          </OverlayTrigger>
                        }
                      </>
                    }
                    </td>
                  </tr>
                )) }
              </tbody>
            </Table>*/}
          </Col>
        </Row>
        {/*<Row>
          <Col md={ 6 } className="table-height">
            <div className="section-subtitle"> Detalle de la orden</div>
            <br/>
            <div> { orden.idOrden > 0 ? <Partidas orden={ orden } /> : <div>Selecciona una orden para conocer su detalle.</div> } </div>
          </Col>

          <Col md={ 6 } className="table-height">
            <div> <Pagos  orden={ orden } /> </div>
          </Col>
        </Row>*/}
      </Container>

    </>
  );
}

export default Compras;
